import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from 'src/constants/other';
import { RootState } from 'src/store';
import { fetchWithRetry } from 'src/utils/fetch-retry';
import { clientSession } from 'src/utils/session-storage';

import { matchesQuizVersion, STALE_QUIZ_REQUEST, VERSION_MISMATCH } from './match-quiz-version';

export const getDuels = createAsyncThunk(
  'data/getDuels',
  async (_, { getState, rejectWithValue }) => {
    const sessionData = clientSession.get();

    if (!sessionData?.partyAId || !sessionData?.partyBId) {
      return rejectWithValue('No parties provided');
    }

    const sessionId = sessionData.sessionId;
    const partiesVersionId = (getState() as RootState).data.main?.versionId;
    const data = await fetchWithRetry(`${API_URL}/public/duels.json`);

    if (clientSession.get()?.sessionId !== sessionId) {
      return rejectWithValue(STALE_QUIZ_REQUEST);
    }

    if (!matchesQuizVersion(data?.versionId, partiesVersionId)) {
      clientSession.remove();
      return rejectWithValue(VERSION_MISMATCH);
    }

    return data;
  },
  {
    condition: (_, { getState }) => {
      const { loadingDuels, duels } = (getState() as RootState).data;

      if (loadingDuels || duels) {
        return false;
      }

      const sessionData = clientSession.get();

      return Boolean(sessionData?.version && sessionData.partyAId && sessionData.partyBId);
    },
  }
);
